/**
 * Every category we support for exclusives.
 *
 * Note: On the backend, these are actually topics.
 */
export enum ExclusiveCategory {
  Adoptable = 'adoptable',
  DigitalArt = 'digital-art',
  GameArt = 'game-art',
  MixedMedia = 'mixed-media',
  Photography = 'photography',
  Pinups = 'pinups',
  TraditionalArt = 'traditional-art',
  ThreeDArt = 'three-d-art',
}

/**
 * Our topic necoids mapped to the appropriate {@link ExclusiveCategory}.
 */
export const necoidToExclusiveCategory = {
  '17': ExclusiveCategory.Adoptable,
  '6': ExclusiveCategory.DigitalArt,
  '9': ExclusiveCategory.GameArt,
  '1331': ExclusiveCategory.MixedMedia,
  '46': ExclusiveCategory.Photography,
  '214': ExclusiveCategory.Pinups,
  '5': ExclusiveCategory.TraditionalArt,
  '10': ExclusiveCategory.ThreeDArt,
} as const;

// Little utility to reverse the above map. This will let us keep type safety if we only have an ExclusiveCategory to reference
type ReverseMap<T extends Record<keyof T, keyof any>> = {
  [P in T[keyof T]]: {
    [K in keyof T]: T[K] extends P ? K : never;
  }[keyof T];
};

/**
 * Our {@link ExclusiveCategory} enum mapped to the appropriate topic necoid.
 */
export const exclusiveCategoryToNecoid: ReverseMap<typeof necoidToExclusiveCategory> = {
  [ExclusiveCategory.Adoptable]: '17',
  [ExclusiveCategory.DigitalArt]: '6',
  [ExclusiveCategory.GameArt]: '9',
  [ExclusiveCategory.MixedMedia]: '1331',
  [ExclusiveCategory.Photography]: '46',
  [ExclusiveCategory.Pinups]: '214',
  [ExclusiveCategory.TraditionalArt]: '5',
  [ExclusiveCategory.ThreeDArt]: '10',
};

/**
 * Takes a necoid (converted to a string, for typescript reasons) and returns the appropriate {@link ExclusiveCategory}.
 */
export function getExclusiveCategoryByNecoid(key: keyof typeof necoidToExclusiveCategory) {
  return necoidToExclusiveCategory[key];
}

/**
 * Takes an {@link ExclusiveCategory} and returns the appropriate necoid.
 */
export function getNecoidByExclusiveCategory(key: ExclusiveCategory) {
  return exclusiveCategoryToNecoid[key];
}
